import { useRouteError } from 'react-router';
import { ErrorDisplay } from '@/components/ui/feedback/error-display';
import { RELOAD_FLAG_KEY } from '@/lib/lazy-with-retry';

function isChunkLoadError(error: unknown): boolean {
  if (error instanceof TypeError) {
    const msg = error.message.toLowerCase();
    return (
      msg.includes('dynamically imported module') || // Chrome / Edge
      msg.includes('importing a module script failed') || // Safari
      msg.includes('error loading dynamically imported module') // Firefox
    );
  }
  return false;
}

export function RouteErrorFallback() {
  const error = useRouteError();
  const isChunkError = isChunkLoadError(error);

  const handleReload = () => {
    sessionStorage.removeItem(RELOAD_FLAG_KEY);
    window.location.reload();
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-bg-tertiary">
      <ErrorDisplay
        icon={isChunkError ? 'info' : 'warning'}
        title={
          isChunkError
            ? 'A new version of the app is available'
            : 'Something went wrong'
        }
        message={
          isChunkError
            ? 'The app has been updated since you last loaded it. Please reload to get the latest version.'
            : 'An unexpected error occurred. Reloading may fix the issue.'
        }
        retryText="Reload"
        onRetry={handleReload}
        fullPage={false}
      />
    </div>
  );
}
